export function showAiActionsMarkTextPopup(): Promise<'let-me-mark' | 'modify-all' | 'cancel'> {
  return new Promise((resolve) => {
    const contents = `
    <style nonce="CSP_STYLE_NONCE_PLACEHOLDER">
        .ai-actions-dialog-backdrop {
            display: flex;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.4);
            align-items: center;
            justify-content: center;
            z-index: 1000000;
        }

        .ai-actions-dialog-frame {
            position: relative;
            background-color: white;
            border-radius: 5px;
            padding: 20px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            width: 580px;
            display: flex;
            flex-direction: column;
        }

        .ai-actions-dialog-x-button {
          position: absolute;
          top: 22px;
          right: 30px;
          width: 13px;
          height: 13px;
          background-color: transparent;
          border: none;
          cursor: pointer;
        }

        .ai-actions-dialog-x-button::before,
        .ai-actions-dialog-x-button::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 1px;
          background-color: #414D69;
          transform-origin: center;
          border: none;
        }

        .ai-actions-dialog-x-button::before {
          transform: translate(-50%, -50%) rotate(45deg);
        }

        .ai-actions-dialog-x-button::after {
          transform: translate(-50%, -50%) rotate(-45deg);
        }

        .ai-actions-dialog-title {
            font-size: 24px;
            font-weight: 400;
            padding-bottom: 12px;
        }

        .ai-actions-dialog-body {
            font-size: 14px;
            font-weight: 400;
            padding-bottom: 30px;
        }

        .ai-actions-dialog-button-panel {
            display: flex;
            gap: 10px;
            justify-content: end;
        }

        .ai-actions-dialog-button {
            font-size: 14px;
            font-weight: 500;
            border-radius: 4px;
            padding: 10px 16px;
            border: none;
        }

        .ai-actions-dialog-secondary-button {
            background-color: #fff;
            color: #3d41eb;
            transition: background-color 0.3s;
        }

        .ai-actions-dialog-secondary-button:hover {
            background-color: #eee;
        }

        .ai-actions-dialog-secondary-button:active {
            background-color: #ddd;
        }

        .ai-actions-dialog-primary-button {
            cursor: pointer;
            background-color: #3d41eb;
            color: #fff;
            transition: background-color 0.3s;
        }

        .ai-actions-dialog-primary-button:hover {
            background-color: #181ce5;
        }

        .ai-actions-dialog-primary-button:active {
            background-color: #1215ac;
        }
    </style>

    <div class="ai-actions-dialog-backdrop">
        <div class="ai-actions-dialog-frame">
            <button class="ai-actions-dialog-x-button"></button>
            <div class="ai-actions-dialog-title">
                Select Text to Modify
            </div>
            <div class="ai-actions-dialog-body">
                Please mark the text you want to modify, or would you like to modify it all?
            </div>

            <div class="ai-actions-dialog-button-panel">
                <button class="ai-actions-dialog-button ai-actions-dialog-secondary-button
                    ai-actions-dialog-let-me-mark-button">Let me mark</button>
                <button class="ai-actions-dialog-button ai-actions-dialog-primary-button
                    ai-actions-dialog-modify-all-button">Modify all</button>
            </div>
        </div>
    </div>
  `;

    const dialogRoot = document.createElement('div');
    dialogRoot.className = 'ai-actions-dialog-root';
    dialogRoot.innerHTML = contents;

    document.body.appendChild(dialogRoot);

    dialogRoot.querySelector('.ai-actions-dialog-x-button')?.addEventListener('click', () => {
      resolve('cancel');
      dialogRoot.remove();
    });

    dialogRoot.querySelector('.ai-actions-dialog-let-me-mark-button')?.addEventListener('click', () => {
      resolve('let-me-mark');
      dialogRoot.remove(); // Modify as needed
    });

    dialogRoot.querySelector('.ai-actions-dialog-modify-all-button')?.addEventListener('click', () => {
      resolve('modify-all');
      dialogRoot.remove(); // Modify as needed
    });
  });
}
